module.exports = __webpack_public_path__ + "media/images/seaplane-1078f2ab.png";